import { inject, Service } from "@angular/core";

import { MainResponseModel, ServiceCard, ServiceModel } from "../models";
import { MainService } from "./main-service";

@Service()
export class ServicesApiService {
  private _mainService = inject(MainService);

  public getCardById(id: number) {
    const url = `service/getCardById/${id}`;

    return this._mainService.sendRequest<MainResponseModel<ServiceCard>>({
      url,
      method: "GET",
      loader: true,
    });
  }

  public getService(id: number) {
    const url = `service/getbyid/${id}`;

    return this._mainService.sendRequest<MainResponseModel<ServiceModel>>({
      url,
      method: "GET",
      loader: true,
    });
  }

  public getServicesByMap() {
    const url = `service/getServicesByMap`;

    return this._mainService.sendRequest<MainResponseModel<ServiceModel[]>>({
      url,
      method: "GET",
      loader: true,
    });
  }

  public getSubServicesByMap() {
    const url = `service/getSubServicesByMap`;

    return this._mainService.sendRequest<MainResponseModel<ServiceModel[]>>({
      url,
      method: "GET",
      loader: true,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public updateService(isFinish: boolean, data: any) {
    let url = `service/update`;
    url += `?isFinish=${isFinish}`;

    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      data,
      url,
    });
  }

  public deleteService(serviceId: number) {
    const url = `service/deleteById/${serviceId}`;

    return this._mainService.sendRequest<MainResponseModel<null>>({
      url,
      method: "POST",
      data: {},
    });
  }
}
